import ButtonOutlined from '@components/buttos/button-outlined';
import logger from '@functions/logger';
import { setWalkthrough, setWalkthroughFlow, setWalkthroughStep } from '@redux/slices/walkthrough/walkthrough.slice';
import { RootState } from '@redux/store';
import { finishWalktrough } from '@services/signup';
import { Button } from "@fc/devteam-components-library";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export function Walkthrough(props: { title: string, description: string, titleButton: string,  action: () => void }) {
    const { t } = useTranslation(['walkthrough']);
    const dispatch = useDispatch();
    const personId = useSelector((state: RootState) => state.practitionerProfile.profile.personId);

    const finishTour = async () => {
        try{
            const res = await finishWalktrough(personId, true);
            console.log(res);
        }catch(error) {
            logger.error(error);
        }
        dispatch(setWalkthroughStep({step: 0}),);
        dispatch(setWalkthrough({disabled: true}));
        dispatch(setWalkthroughFlow({flow: ''}));
    }
    return (
        <div className="Walkthrough">
            <p className="Walkthrough__Title">{props.title}</p>
            <div className="Walkthrough__Content">
                <p className="Walkthrough__Text">
                    {props.description}
                </p>
            </div>
            <div className="Walkthrough__ContentInputs">
                <ButtonOutlined
                    label={t('skip')}
                    action={() => finishTour()}                
                />
            </div>
            <Button
                buttontype='button'
                buttontext={props.titleButton}
                action={() => {
                    props.action();
                }}
            />
        </div>
    );
}